import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/error-tips.png'


const _hoisted_1 = { class: "grad-container passTest-tip-container" }
const _hoisted_2 = { class: "grad-inner" }
const _hoisted_3 = { class: "grad-btn-container flex-row pass-test" }
const _hoisted_4 = { class: "grad-countdown" }

import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { NCountdown} from 'naive-ui'
import type { CountdownProps } from 'naive-ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    totalTime: {
        type: Number,   
        default: 3000
    },
},
  emits: ['onFinish'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const startErrorTip = ref(false)
const renderErrorTip: CountdownProps['render'] = ({seconds}) => {
    if(seconds == 0){
        return `00`
    }else{
        return `${String(seconds).padStart(2, '0')}`
    }
}

const handleFinish = () => {
    emits('onFinish')
}

onMounted(() => {
    startErrorTip.value = true
})
onBeforeUnmount(() => {
    startErrorTip.value = false
})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, [
        _createElementVNode("span", null, "提示")
      ], -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "grad-body" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }),
        _createElementVNode("p", null, "通关失败"),
        _createElementVNode("span", null, "飞机已坠毁，即将重新开始当前任务")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(NCountdown), {
            ref: "errorCountdownRef",
            duration: props.totalTime,
            render: renderErrorTip,
            active: startErrorTip.value,
            "on-finish": handleFinish
          }, null, 8, ["duration", "active"]),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text" }, "秒后自动开始", -1))
        ])
      ])
    ])
  ]))
}
}

})